import { getInstance as getBootstrap } from 'utils/bootstrap';
import get from 'lodash/get';
import Logger from 'observability/Logger';
import SplashApiClient from './SplashApiClient';

const LOG = new Logger('SplashApiClient-singleton');
let apiClient;

export default () => {
    if (apiClient) {
        return apiClient;
    }

    const bootstrap = getBootstrap();

    const { splashApiUrl, splashApiAccessToken } = get(bootstrap, 'data.app', {});

    if (!splashApiUrl || !splashApiAccessToken) {
        LOG.debug('[SplashApiClient] singleton - no api url or token.', { splashApiUrl, splashApiAccessToken });
    }

    apiClient = new SplashApiClient({
        baseUrl: splashApiUrl,
        accessToken: splashApiAccessToken,
    });

    return apiClient;
};

export const setApiClient = (newApiClient) => (apiClient = newApiClient);
